export default defineAppConfig({
    languages: ['de', 'fr', 'it', 'en']
})